import script from "./homeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./homeIndex.vue?vue&type=script&setup=true&lang=js"

import "./homeIndex.vue?vue&type=style&index=0&id=2b5f210a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5f210a"]])

export default __exports__